import { injectIntl } from 'react-intl';
import React, { useState, useContext, useRef, useEffect } from 'react';
import { Skeleton, Divider } from 'antd'
import Router from 'next/router';
import {  DownOutlined, UpOutlined } from '@ant-design/icons';
import myContext from '@/utils/createContext';
import { getInitProductsOrder } from '@/components/H5PC/service';
import { CopyOutlined, CreditCardOutlined } from '@ant-design/icons';


import { getUrlPrefix, NumFormat, reportEventToMonitor } from '@/utils/index';


import {
	CommonJudgePaymentStatus
} from '@/components/H5PC/CommonMethod';


const ProductInfo = (props) => {
	const { intl } = props;
	const { formatMessage } = intl;
	const { isMobileView, key, merchantTheme, cashierData } = useContext(myContext);

	
	const {
		logoUrl,
		webDomain
	} = merchantTheme || {};

	const {
		actualPaymentCurrency,
		totalCurrencySymbol,
		orderServiceChargeAmount,
		orderServiceChargeRate,
		description,
		totalAmount,
		products,
		ablePaymentCurrencyList,
		merchantServiceChargeModel
	} = cashierData || '';
	console.log('products', products);
	// More Less Dom Action
	const itemsRefs = useRef([]);
	const moreRefs = useRef([]);
	const lessRefs = useRef([]);

	// 增加骨架屏设置
	const [isShowProducts, setIsShowProducts] = useState(false);

	const [productsDetail, setProductsDetail] = useState(null)

	const [productsMap, setProductsMap] = useState([]);
	const [mShowSummary, setMShowSummary] = useState(false);
	const [spanListWidth, setSpanListWidth] = useState([])


	const three3Ds2Ref = useRef(null)
	const linkRef = useRef(null)
	const three3Ds1Ref = useRef(null)

	const copyCardNo = async (copyCardNo) => {
		try {
			await navigator.clipboard.writeText(copyCardNo);
			console.log('Content copied to clipboard');
			message.success(formatMessage({ id: 'ga-checkout.demo.copied-success' }));
		} catch (err) {
			console.error('Failed to copy: ', err);
		}
	}



	/****** 初始化移动端按钮方向向下 ******/
	useEffect(() => {
		fetchProductsData(key);
	}, []);

	const fetchProductsData = async (key) => {
		const urlPrefix = getUrlPrefix();

		// 计算接口耗时
		const startTime = new Date().getTime();

		const res = await getInitProductsOrder(key);

		const endTime = new Date().getTime();
		const consumedTime = endTime - startTime;

		consumedTime >= 5000 && reportEventToMonitor(`接口耗时报警(cashier_interface_time): time=${consumedTime}ms; 产品接口url=/payment/${key}/products;`)
		

		setIsShowProducts(!isShowProducts);
		
		const redirectUrl = res && res.data && res.data.redirectUrl;
		if (res?.code === 409015) { 
			Router.push(`/time-out`);
			return;
		}
		if (redirectUrl) {
			if (redirectUrl.indexOf('http') > -1) {
				window.location.href = redirectUrl;
			} else {
				window.location.href = `${urlPrefix}${redirectUrl}`;
			}
		} else {
			setProductsDetail(res && res.data);
			// 判断支付成功失败
			CommonJudgePaymentStatus(props, res && res.data, isMobileView);

			const newProducts = res && res.data && res.data.products || [];

			

			let _html = ''
			newProducts?.map((item, k) => { 
				_html += `<span key=${k} style="display: inline-block">${ item.title}</span>`
			})
			if(document.getElementById('spanDivListRefs')){
			   document.getElementById('spanDivListRefs').innerHTML = _html
			}

			const productWidthAll = document.getElementById('spanDivListRefs')?.querySelectorAll('span') || [];


			let newSpanListWidth = []
			productWidthAll?.forEach((x,y ) => { 
				newSpanListWidth.push(x.offsetWidth);
			})

			setSpanListWidth([...newSpanListWidth])
            if(document.getElementById('spanDivListRefs')){
			   document.getElementById('spanDivListRefs').remove()
			}

			setProductsMap(newProducts)

		}
	}

	const clickProductMore = () => { 
		isMobileView && setMShowSummary(!mShowSummary);
	}


	const renderProductInfo = () => {
		const { llbrIofAmount, llbrIofCurrency, llbrIofRate } = cashierData || {};
		return (
			<div className={`${isMobileView ? 'order-products-mobile' : ''}`} style={{opacity: isMobileView && !mShowSummary ? '0' : '1', zIndex: isMobileView && !mShowSummary ? '-1' : '99'}}>
				<div className='order-products'>
					{ 
						description ? 
							<div className='order-products-item'>
								<div className="order-products-item-title">
									<div className='order-products-item-title-left'>
										<span className='order-products-item-title-name'>
											{formatMessage({ id: 'ga-checkout.description'})}
										</span>
									</div>
									<span className='order-products-item-title-total'>
										<span className='order-products-item-title-name'>
											{description}
										</span>
									</span>
								</div>
							</div>
							:
							null
					}
					
					{
						productsMap?.map((item, k) => {

							return (
								<div className='order-products-item' key={k}>
									<div className="order-products-item-title">
										<div className='order-products-item-title-left'>
											<span className={`order-products-item-title-name product-list-left-title-${k}`} key={k} ref={(el) => (itemsRefs.current[k] = el)} style={{ whiteSpace: 'nowrap' }}>
												{item.title}
											</span>

											<span
												className='order-products-item-title-more'
												ref={(el) => { moreRefs.current[k] = el }}
												style={{
													display: spanListWidth[k] >= 188 ? 'inline-block' : 'none'
												}}
												onClick={
													() => {
														itemsRefs.current[k].style.whiteSpace = 'normal';
														moreRefs.current[k].style.display = 'none';
														lessRefs.current[k].style.display = 'inline-block';
													}
												}
											>
												<>{formatMessage({ id: 'ga-checkout.product-info.more' })}</>
											</span>
											
											<div className='order-products-item-title-more'
												style={{
													display: 'none',
												}}
												onClick={() => { 
													itemsRefs.current[k].style.whiteSpace = 'nowrap'
													moreRefs.current[k].style.display = 'inline-block';
													lessRefs.current[k].style.display = 'none';
												}}
												ref={(el) => { lessRefs.current[k] = el }}
											>
												{formatMessage({ id: "ga-checkout.product-info.less" })}
											</div>

										</div>

										<span className='order-products-item-title-total'>
											{item?.itemTotalPrice + ' ' + productsDetail?.currency}
										</span>
									</div>
									<div className='order-products-item-content'>
										<span className='order-products-item-content-price'>
											{formatMessage({ id: 'ga-checkout.product-info.item-price' })}:&nbsp;
											{item?.itemPrice + ' ' + productsDetail?.currency}
										</span>
										<span>
											{formatMessage({ id: 'ga-checkout.product-info.qty' })}: {item?.qty}
										</span>
									</div>
								</div>
							)
						})
					}
					{ 
						productsMap?.length > 0 ?
							''
							:
							products
					}
				</div>

				<Divider style={{ marginBottom: '10px', background: '#DDDDDD', marginTop: 0 }} />
				<div className='order-products-footer'>
					<div className="order-summary-footer-subtotal">
						<span className='order-summary-footer-left'>{formatMessage({ id: 'ga-checkout.product-info.subtotal' })}</span>
						<span className='order-summary-footer-right'>{productsDetail?.subtotal + ' ' + productsDetail?.currency}</span>
					</div>
					<div className="order-summary-footer-fee">
						{ 
							orderServiceChargeRate ?
								<span className="product-lists-bottom-item-title color-333333">{formatMessage({ id: "ga-checkout.product-info.Payment-process-fee-title" })} ({orderServiceChargeRate}%)</span>
								:
								<span className="product-lists-bottom-item-title color-333333">{formatMessage({ id: "ga-checkout.product-info.other" })}</span>
						}
						<span className='order-summary-footer-right'>{productsDetail?.other + ' ' + productsDetail?.currency}</span>
					</div>
					{
						llbrIofAmount && llbrIofRate && llbrIofCurrency && (
							<div className="order-summary-iof-amount">
								<span className='order-summary-footer-left'>IOF({llbrIofRate})</span>
								<span className='order-summary-footer-right'>{llbrIofAmount} {llbrIofCurrency}</span>
							</div>
						)
					}
					<div className="order-summary-footer-total" style={{ marginTop: '16px' }}>
						<span className='order-summary-footer-left'>{formatMessage({ id: 'ga-checkout.total' })}</span>
						<span className='order-summary-footer-right order-summary-footer-right-amount'>{productsDetail?.total + ' ' + productsDetail?.currency}</span>
					</div>
				</div>
			</div>
		)
	}

	const renderProductZDInfo = () => {
		const paymentAmount = NumFormat(parseFloat(totalAmount) - parseFloat(orderServiceChargeAmount ? orderServiceChargeAmount : '0.00'));

		return (
			<div className={`${isMobileView ? 'order-products-mobile' : ''}`} style={{ opacity: isMobileView && !mShowSummary ? '0' : '1', zIndex: isMobileView && !mShowSummary ? '-1' : '99' }}>
				<div className='order-products'>
					<div className='order-products-item'>
						<div className="order-products-item-title">
							<div className='order-products-item-title-left'>
								<span className='order-products-item-title-name'>
									{
										products ?
											<span>{products}</span>
											:
											formatMessage({ id: "ga-checkout.product-info.tuition-fee" })
									}
								</span>
							</div>
							<span className='order-products-item-title-total'>
								{totalCurrencySymbol} {paymentAmount ? paymentAmount : '0.00'} {actualPaymentCurrency}
							</span>
						</div>
					</div>
				</div>
				<Divider style={{ marginBottom: '10px', background: '#DDDDDD', marginTop: 0 }} />
				{ 
					orderServiceChargeRate ?
						<div className='order-products' style={{ paddingBottom: 10 }}>
							<div className='order-products-item'>
								<div className="order-products-item-title">
									<div className='order-products-item-title-left'>
										<span>
											{formatMessage({ id: "ga-checkout.product-info.Payment-process-fee-title" })} ({orderServiceChargeRate}%)
										</span>
									</div>
									<span className='order-products-item-title-total'>
										{totalCurrencySymbol} {orderServiceChargeAmount ? orderServiceChargeAmount : '0.00'} {actualPaymentCurrency}
									</span>
								</div>
							</div>
						</div>
						:
						null
				}
				

				<div className='order-products-footer'>
					<div className="order-summary-footer-total">
						<span className='order-summary-footer-left'>{formatMessage({ id: "ga-checkout.product-info.total" })}</span>
						<span className='order-summary-footer-right order-summary-footer-right-amount'>{totalCurrencySymbol} {totalAmount} {actualPaymentCurrency}</span>
					</div>
				</div>
			</div>
		)
	}



	return (
		<div className="h5pc-order-info" id="productsOrder" style={{ position: 'relative', width: '100%' }}>
			{
				logoUrl
					?
					<img className="vh5pc-cashier-logo-container-image" src={logoUrl} alt={webDomain} style={
						{marginTop: isMobileView? '20px': 0 }
					} />
					:
					''
			}
			{
				productsDetail ?
					<div style={{ position: 'relative'}}>
						<div className="order-summary-title" onClick={clickProductMore} style={{ marginTop: logoUrl ? '24px': 0 }}>
							{formatMessage({ id: 'ga-checkout.order-summary' })}
							{
								isMobileView ?
									!mShowSummary ?
										<DownOutlined />
										:
										<UpOutlined />
									:
									null
							}
						</div>
						<div className="order-summary-amount">
							{productsDetail?.total + ' ' + productsDetail?.currency}
						</div>
						{
							ablePaymentCurrencyList || merchantServiceChargeModel === 'DCC' || orderServiceChargeRate ?
								renderProductZDInfo()
								:
								renderProductInfo()
						}
					</div>
					:
					<Skeleton />
			}
			<div id={'spanDivListRefs'} style={{ opacity: 0 }}></div>
			
			{
				!isMobileView && ((sessionStorage.getItem('llpayReferrer') || '').indexOf('acquiring.lianlianpay.com') != -1 ||
				    (document.querySelector('head meta')?.content || '').indexOf('acquiring.lianlianpay.com') != -1 ||
					(sessionStorage.getItem('llpayReferrer') || '').indexOf('localhost:8085') != -1) ?

					<div className={'vh5pc-cashier-container-right-card'}>
						<div className={'vh5pc-cashier-container-right-card-title'}>
							<CreditCardOutlined />
							{formatMessage({ id: "ga-checkout.demo.test-card" })}
						</div>
						<p>{formatMessage({ id: "ga-checkout.demo.test-card-try" })}</p>
						<ul>
							<div>{formatMessage({ id: "ga-checkout.demo.test-card-no-3ds" })}&nbsp;:</div>
							<li>

								<span ref={linkRef}>4200 0000 0000 0000</span>

								<div>
									<CopyOutlined onClick={() => copyCardNo(linkRef.current.innerText)} />
								</div>
							</li>
							<hr />
							<div>{formatMessage({ id: "ga-checkout.demo.test-card-3ds" })}&nbsp;:</div>
							<li >
								<span ref={three3Ds1Ref}>4711 1000 0000 0000</span>
								<div >
									<CopyOutlined onClick={() => copyCardNo(three3Ds1Ref.current.innerText)} />
								</div>
							</li>
						</ul>
					</div>
					:
					null
			}
		</div>
	)
}

export default injectIntl(ProductInfo);